import { Component, OnInit, HostListener } from "@angular/core";
import { ApiService } from "../services/api.service";
import { SelectedProduct } from "./checkout.reducer";
import { CheckoutService } from "../services/checkout.service";

@Component({
    selector: "server-list",
    templateUrl: "./checkout-server-list.component.html",
    styleUrls: ['../../assets/sass/checkout.scss']
})
export class CheckoutServerListComponent implements OnInit {
    filterButtonVisibility = false;
    menu;
    filtersModel = {};
    filtersActive = {};
    filters = [];
    products = [];

    constructor(
        private apiService: ApiService,
        private checkoutService: CheckoutService,
    ) {
        this.apiService.get('/offer/products').subscribe(response => {
            this.filters = response.filters;
            this.products = response.products;

            this.prepareFiltersModel();
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth < 990) {
            this.filterButtonVisibility = true;
            this.menu.style.width = '0';
            return;
        }
        this.filterButtonVisibility = false;
        this.menu.style.width = '200px';
    }

    ngOnInit() {
        this.menu = document.getElementById('sidebar');
        if (window.innerWidth < 990) {
            this.filterButtonVisibility = true;
            this.menu.style.width = '0';
        }
    }
    toggleMenu() {
        this.menu.style.width = this.menu.offsetWidth ? '0' : '200px';
    }

    goToServer(server) {
        if (server.url) {
            window.open(server.url, '_blank');
        }
    }

    prepareFiltersModel() {
        this.filters.forEach(filter => {
            if (!this.filtersModel.hasOwnProperty(filter.key)) {
                this.filtersModel[filter.key] = {};
            }
            if (!this.filtersActive.hasOwnProperty(filter.key)) {
                this.filtersActive[filter.key] = [];
            }
            filter.values.forEach(value => {
                this.filtersModel[filter.key][value] = false;
            });
        });
    }

    setFilter(event, slot, element) {
        if (event) {
            this.filtersActive[slot].push(element);
        } else {
            let index = this.filtersActive[slot].indexOf(element);
            this.filtersActive[slot].splice(index, 1);
        }
    }

    fillSelectedProduct(product: SelectedProduct) {
        this.checkoutService.setSelectedProduct(product);
    }
}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout-server-list.component.ts